<template>
  <div class="schedule">
    <div
      class="day"
      v-for="[d, val] in schedule_pairs"
      :key="d"
    >
      <span class="day-label">{{ shortDay(d) }}</span>
      <span :class="[isClosed(val) ? 'text-orange' : 'time-bold']">{{ isClosed(val) ? 'вихідний' : val || '–' }}</span>
    </div>
  </div>
</template>

<script>
const DAYS = ["Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота", "Неділя"];
const SHORT = ["пн", "вт", "ср", "чт", "пт", "сб", "нд"];
const DAY_CODES = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export default {
  props: ["schedule"],

  computed: {
    schedule_pairs() {
      const schedule = this.schedule;
      if (Array.isArray(schedule)) {
        const normalized = schedule.slice(0, 7);
        while (normalized.length < 7) {
          normalized.push(undefined);
        }
        return DAYS.map((day_name, index) => [day_name, normalized[index]]);
      } else if (schedule && typeof schedule === 'object') {
        const lowerKeys = {};
        for (const key in schedule) {
          if (Object.prototype.hasOwnProperty.call(schedule, key)) {
            lowerKeys[key.toLowerCase()] = schedule[key];
          }
        }
        return DAYS.map((day_name, index) => {
          const val = lowerKeys[DAY_CODES[index]] || undefined;
          return [day_name, val];
        });
      } else {
        return DAYS.map(day_name => [day_name, undefined]);
      }
    }
  },

  methods: {
    isClosed(value) {
      return value && value.trim().toLowerCase() === "не працює";
    },
    shortDay(full) {
      let idx = DAYS.indexOf(full);
      return SHORT[idx] || full;
    }
  }
};
</script>

<style lang="scss" scoped>
.schedule {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.day {
  font-size: 16px;
  display: flex;
  gap: 8px;
  line-height: 1.4;
}

.day-label {
  min-width: 2.5em;
  font-weight: 400;
}

.time-bold {
  font-weight: 600;
}

.text-orange {
  color: var(--col-text-orange) !important;
  font-weight: 600;
}
</style>
